import React, { Dispatch, FC, SetStateAction } from 'react';
import { ModalType } from '@v2/pages/common/enums';
import { ColorFunction } from '@styles/colors/types';
import { isPhone, isWeb } from '@helpers';
import { notchTop, scale } from '@components/frame';
import { connect } from 'react-redux';
import ModalWrapper from '@components/modal/ModalWrapper';
import NCFileModal from './ncFile/NCFileModal';
import PartModal from './part/PartModal';
import ToolModal from './tool/ToolModal';
import { View } from 'react-native';

interface DetailsPageModalsProps {
  C: ColorFunction;
  setActionsModalOpen: Dispatch<SetStateAction<boolean>>;
  actionsModalOpen: boolean;
  isWithERP: boolean | null;
  modalType: ModalType;
  setShouldShowGlobalFullNCFileButton: (state: boolean) => void;
}

const DetailsPageModals: FC<DetailsPageModalsProps> = ({ C, setActionsModalOpen, isWithERP, modalType, actionsModalOpen }) => {
  if (!modalType || !actionsModalOpen) {
    return null;
  }

  const props = {
    minWidth: 263,
    C,
    setActionsModalOpen,
  };

  const getModalContent = {
    [ModalType.NC_FILE]: () => <NCFileModal {...props} />,
    [ModalType.PART]: () => (isWithERP ? null : <PartModal {...props} />),
    [ModalType.TOOLS]: () => <ToolModal {...props} />,
    [ModalType.BATCH]: () => null,
    [ModalType.JOBS]: () => null,
  };

  const modalContent = getModalContent?.[modalType]?.();

  if (!modalContent) return;

  return (
    <ModalWrapper
      {...{
        C,
        onBackdropPress: () => setActionsModalOpen(false),
        isVisible: actionsModalOpen,
        withPositionedContainer: true,
        positionedContainerStyles: { top: scale(isWeb ? 113 : !isPhone ? 67 : 48 + notchTop), right: scale(!isWeb ? 7 : 10) },
      }}
    >
      {modalContent}
    </ModalWrapper>
  );
};

export default connect(({ membership: { isWithERP } }) => ({ isWithERP }), {})(DetailsPageModals);
